import { executeGraphQL } from '../../../src/graphql/executeGraphQL';
import type { GraphQLRequestOverrides, GraphqlDocumentOperation } from '../../../src/graphql/executeGraphQL';
import type { GqlCreateVantageInvestigationMutation, GqlCreateVantageInvestigationMutationVariables } from './CreateVantageInvestigation';
import type { GqlVantageConditionDependenciesQuery, GqlVantageConditionDependenciesQueryVariables } from './VantageConditionDependencies';
import type { GqlVantageWorksheetCreatorsQuery, GqlVantageWorksheetCreatorsQueryVariables } from './VantageWorksheetCreators';

const CreateVantageInvestigationOperation: GraphqlDocumentOperation = {
  name: 'CreateVantageInvestigation',
  type: 'mutation',
  document: `mutation CreateVantageInvestigation($input: VantageInvestigationInput!) {
  createVantageInvestigation(input: $input) {
    workbookId
    url
    worksheetIds
    noteErrors
  }
}`,
};

const VantageConditionDependenciesOperation: GraphqlDocumentOperation = {
  name: 'VantageConditionDependencies',
  type: 'query',
  document: `query VantageConditionDependencies($conditionIds: [ID!]!, $depth: Int!) {
  vantageConditionDependencies(conditionIds: $conditionIds, depth: $depth) {
    conditionId
    dependencies {
      id
      name
      type
      fingerprint
    }
  }
}`,
};

const VantageWorksheetCreatorsOperation: GraphqlDocumentOperation = {
  name: 'VantageWorksheetCreators',
  type: 'query',
  document: `query VantageWorksheetCreators($workbookId: ID!) {
  workbook(id: $workbookId) {
    worksheets {
      id
      creatorId: property(name: "creatorId")
      creatorName: property(name: "creatorName")
    }
  }
}`,
};

export class sqVantageGqlApiClass {
  /** GraphQL mutation CreateVantageInvestigation (src/graphql/operations/vantage/CreateVantageInvestigation.graphql) */
  public createVantageInvestigation(
    variables: GqlCreateVantageInvestigationMutationVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlCreateVantageInvestigationMutation> {
    return executeGraphQL(CreateVantageInvestigationOperation, variables, overrides);
  }

  /** GraphQL query VantageConditionDependencies (src/graphql/operations/vantage/VantageConditionDependencies.graphql) */
  public vantageConditionDependencies(
    variables: GqlVantageConditionDependenciesQueryVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlVantageConditionDependenciesQuery> {
    return executeGraphQL(VantageConditionDependenciesOperation, variables, overrides);
  }

  /** GraphQL query VantageWorksheetCreators (src/graphql/operations/vantage/VantageWorksheetCreators.graphql) */
  public vantageWorksheetCreators(
    variables: GqlVantageWorksheetCreatorsQueryVariables,
    overrides?: GraphQLRequestOverrides,
  ): Promise<GqlVantageWorksheetCreatorsQuery> {
    return executeGraphQL(VantageWorksheetCreatorsOperation, variables, overrides);
  }
}

export const sqVantageGqlApi = new sqVantageGqlApiClass();
